import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import MaquinaModel from '../../models/Maquina';

export default function MaquinaForm(props) {

  const [maquina, setMaquina] = useState({ ...MaquinaModel });
  const [savingFlag, setSavingFlag] = useState(false);

  useEffect(() => {
    if (props.maquina) {
      setMaquina({ ...props.maquina });
    }
  }, [props.maquina]);

  async function saveMaquina(e) {
    e.preventDefault();
    setSavingFlag(true);
    let resp;
    try {
      resp = await api.post('/maquinas', maquina);
    } catch (error) {
      if (error.response.status < 500) {
        alert(error.response.data.description);
      } else {
        alert("Ocorreu um erro no servidor. Tente novamente ou entre em contato com o suporte.");
      }
      setSavingFlag(false);
      return;
    }
    setSavingFlag(false);
    if (props.onSave) {
      props.onSave(resp.data);
    }
  }

  function cancel(e) {
    if (props.onCancel) props.onCancel(e);
  }

  return (
    <>
      <div>
        <form className="cor-form" onSubmit={saveMaquina}>
          <div className="form-group">
            <label>Nome:</label>
            <input
              type="text"
              className="form-control"
              value={maquina.nome}
              onChange={e => {
                maquina.nome = e.target.value;
                setMaquina({ ...maquina });
              }}
            />
          </div>
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                checked={maquina.status == 'ativo' ? true : false}
                onChange={e => {
                  maquina.status = e.target.checked ? 'ativo' : 'inativo';
                  setMaquina({ ...maquina });
                }}
              /> Ativo
            </label>
          </div>
          <div className="btn-group mr-2" role="group">
            <button type="button" className="btn btn-secondary" onClick={cancel}>Cancelar</button>
          </div>
          <div className="btn-group" role="group">
            <button type="submit" className={`btn btn-primary ${savingFlag ? 'disabled':''}`}>
              {savingFlag ? 'Salvando' : 'Salvar'}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}